// extracted by mini-css-extract-plugin
export default {"peopleListElement":"PeopleListElement_peopleListElement__5y-VP"};